<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="page-links">
            <router-link to="/settings/territory" class="page-links__item"
              >Territory</router-link
            >
            <router-link
              to="/settings/location"
              class="page-links__item is-active"
              >Location</router-link
            >
            <router-link to="/settings/area" class="page-links__item"
              >Area</router-link
            >
            <router-link to="/settings/airstrip" class="page-links__item"
              >Airstrip</router-link
            >
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--location" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Geo | Location</h2>
            </div>
            <div class="geo-section__add">
              <div class="section-title">
                <h3>Add Location</h3>
              </div>
              <form
                action="javascript:void(0)"
                class="geo-section__location-form">
                <div class="add-block__container">
                <div class="form-control-group">
                  <span class="form-control-label">Title</span>
                  <div
                    :class="['form-control-wrap', {'is-error': errors.title}]">
                    <input
                      type="text"
                      Placeholder="Title"
                      @focus="errors.title = false"
                      v-model="add.title"
                      class="form-control" />
                  </div>
                </div>
                <div
                  :class="[
                    'form-control-group',
                    {'is-error': errors.territory},
                  ]">
                  <span class="form-control-label">Territory</span>
                  <div
                    :class="[
                      'select-wrapper',
                      {'is-active': selects.territory},
                    ]"
                    @click="
                      selects.territory = !selects.territory
                      errors.territory = false
                    ">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                        territories.find((item) => item.active)
                          ? territories.find((item) => item.active).names.EN
                          : 'Choose'
                      }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                          v-for="item in territories"
                          :key="item.id"
                          :class="[
                            'select-option',
                            {'is-selected': item.active},
                          ]"
                          @click="
                            territories = territories.map((territory) =>
                              territory.id === item.id
                                ? {...territory, active: true}
                                : {...territory, active: false}
                            )
                          ">
                          <span class="select-option__name">{{
                            item.names.EN
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-control-group">
                  <span class="form-control-label">Place ID</span>
                  <div
                      :class="['form-control-wrap', {'is-error': errors.googlePlaceId }]">
                    <input
                        type="text"
                        Placeholder="Place ID"
                        @focus="errors.googlePlaceId = false"
                        v-model="add.googlePlaceId"
                        class="form-control" />
                  </div>
                </div>
                </div>
                <button
                  type="submit"
                  class="btn btn--green geo-section__location-form__submit"
                  @click="addLocationHandler">
                  <span>Add</span>
                </button>
              </form>
            </div>
            <div class="geo-section__location">
              <div class="section-title">
                <h3>Locations</h3>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="search"
                    class="form-control-search" />
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo">
                  <div class="section-table__head">
                    <div class="col col-location"><span>Location</span></div>
                    <div class="col col-territory"><span>Territory</span></div>
                    <!--                    <div class="col col-transfer-territorial"><span>Transfer territorial</span></div>-->
                    <div class="col col-added"><span>Added</span></div>
                    <div class="col col-edited"><span>Edited</span></div>
                  </div>
                  <div class="section-table__body">
                    <div
                      class="section-table__row"
                      v-for="(item, index) in locations.slice(
                        (page - 1) * 15,
                        (page - 1) * 15 + 15
                      )"
                      :key="item.location.id">
                      <div class="col col-location">
                        <div class="section-table__row__number">
                          {{ index + 1 }}
                        </div>
                        <div class="section-table__row__name">
                          {{ item.location.names.EN }}
                        </div>
                      </div>
                      <div class="col col-territory">
                        <span>{{ item.territory.names.EN }}</span>
                      </div>
                      <!--                      <div class="col col-transfer-territorial">-->
                      <!--                        <svg width="1em" height="1em" class="icon icon-check " v-if="item.location.transferTerritorial">-->
                      <!--                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>-->
                      <!--                        </svg>-->
                      <!--                      </div>-->
                      <div class="col col-added">
                        <span>{{ item.location.createdAt }}</span>
                      </div>
                      <div class="col col-edited">
                        <span>{{ item.location.updatedAt }}</span>
                      </div>
                      <div class="col col-actions">
                        <button
                          type="button"
                          class="btn btn--edit"
                          @click="editLocation(item.location.id)">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="btn btn--remove"
                          @click="
                            $emit('deleteModalHandler', {
                              entity: 'Location',
                              name: item.location.title,
                              handler: deleteLocationHandler,
                              id: item.location.id,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                :page="page"
                :pageCount="pageCount"
                @pageController="pageController" />
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--location">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon" :style="{minWidth: '21px'}">
                <svg width="1em" height="1em" class="icon icon-edit">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span :style="{whiteSpace: 'nowrap'}">Edit Location</span>
            </div>
            <div
              class="form-control-group form-control-group-lang-horiz"
              :style="{justifyContent: 'flex-end', marginRight: '2rem'}">
              <span class="form-control-label">Language:</span>
              <div
                :class="[
                  'select-wrapper select-wrapper__lang',
                  {'is-active': selects.langEdit},
                ]"
                @click="changeSelects('langEdit')"
                :style="{width: '16rem'}">
                <div class="select-trigger">
                  <div class="select-trigger__flag__icon">
                    <svg
                      width="1em"
                      height="1em"
                      class="icon icon-rus"
                      :style="
                        langEdit === 'DE' || langEdit === 'ES'
                          ? {width: '18px', height: '18px', marginBottom: '1px'}
                          : {}
                      ">
                      <use
                        :xlink:href="getLanguageIcon(langEdit)"></use>
                    </svg>
                  </div>
                  <span class="select-trigger__name">{{getLanguageTitle(langEdit)}}</span
                  ><span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                  ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('RU')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-ru">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ru"></use>
                          </svg>
                        </div>
                        Russian
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('EN')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-usa">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-usa"></use>
                          </svg>
                        </div>
                        English
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('DE')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                          </svg>
                        </div>
                        Deutch
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('ES')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                          </svg>
                        </div>
                        Spanish
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('FR')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                          </svg>
                        </div>
                        French
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('PT')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                          </svg>
                        </div>
                        Portuguese
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="currentLangSelectOption('NL')">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                          </svg>
                        </div>
                        Dutch
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="edit-popup__close"
              @click="
                isEdit
                  ? $emit('notLeavePopupHandler', {
                      handler: clearEdit,
                    })
                  : (edit = null)
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__side">
              <div class="form-control-group">
                <span class="form-control-label">Title</span>
                <div
                  :class="[
                    'form-control-wrap',
                    {'is-error': errorsEdit.title},
                  ]">
                  <input
                    type="text"
                    Placeholder="Title"
                    v-model="edit.names[langEdit]"
                    @change="isEdit = true"
                    @focus="errorsEdit.title = false"
                    class="form-control" />
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div
                :class="[
                  'form-control-group',
                  {'is-error': errorsEdit.territory},
                ]">
                <span class="form-control-label">Territory</span>
                <div
                  :class="[
                    'select-wrapper',
                    {'is-active': selects.territoryEdit},
                  ]"
                  @click="
                    selects.territoryEdit = !selects.territoryEdit
                    errorsEdit.territory = false
                  ">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                      territoriesEdit.find((item) => item.active)
                        ? territoriesEdit.find((item) => item.active).names[
                            langEdit
                          ] ||
                          territoriesEdit.find((item) => item.active).names[
                            'EN'
                          ]
                        : 'Choose'
                    }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                    ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                        v-for="item in territoriesEdit"
                        :key="item.id"
                        :class="['select-option', {'is-selected': item.active}]"
                        @click="
                          territoriesEdit = territoriesEdit.map((territory) =>
                            territory.id === item.id
                              ? {...territory, active: true}
                              : {...territory, active: false}
                          )
                          isEdit = true
                        ">
                        <span class="select-option__name">{{
                          item.names[langEdit] || item.names['EN']
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group">
                <span class="form-control-label">Place ID</span>
                <div
                    :class="[
                    'form-control-wrap',
                    {'is-error': errorsEdit.googlePlaceId},
                  ]">
                  <input
                      type="text"
                      Placeholder="Place ID"
                      v-model="edit.googlePlaceId"
                      @change="isEdit = true"
                      @focus="errorsEdit.googlePlaceId = false"
                      class="form-control" />
                </div>
              </div>
            </div>
            <div class="edit-popup__side-editor">
              <div class="js-ckeditor">
                <editor
                  :editor="editor"
                  v-model="
                    data[lang.territoriesDescription].territoriesDescription
                  "
                  @focus="isEditFlag = true"
                  :config="editorConfig">
                </editor>
              </div>
            </div>
            <div class="edit-popup__side">
              <div
                v-for="location in currentLocationData"
                :key="location.locationId"
                class="form-control-photo-group form-control-photo-group--squared">
                <input
                  type="file"
                  :id="'photo_load' + location.locationId"
                  class="input-hidden" />
                <label
                  class="form-control-photo"
                  v-if="!location.photoId && !uploadedFileId"
                  @click="
                    idPhoto = +location.locationId.toString()
                    $emit('changeImage', 'settings')
                  "
                  ><span class="form-control-photo__box"></span
                ></label>
                <div
                  class="form-control-photo"
                  v-if="uploadedFileId ? uploadedFileId : location.photoId">
                  <span class="form-control-photo__box h-object-fit"
                    ><img
                      :src="`${API}/documents/share/images/${
                        uploadedFileId ? uploadedFileId : location.photoId
                      }?size=LARGE`"
                      alt="photo"
                  /></span>
                  <button
                    type="button"
                    class="btn btn--remove"
                    @click="
                      location.photoId = null
                      uploadedFileId = null
                    ">
                    <svg width="1em" height="1em" class="icon icon-close">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                    </svg>
                  </button>
                </div>
                <div class="form-control-photo-content">
                  <div class="form-control-photo-content__line">
                    <span class="form-control-photo-name">Photo</span>
                  </div>
                  <div class="form-control-photo-content__line">
                    <label
                      class="btn btn--rounded btn-photo-load"
                      @click="
                        idPhoto = +location.locationId.toString()
                        $emit('changeImage', 'settings')
                      "
                      >{{
                        location.photoId ? 'Change photo' : 'Add Photo'
                      }}</label
                    >
                  </div>
                  <div class="form-control-photo-content__line">
                    <span class="form-control-photo-content__size"
                      >Minimum image size: <b>664 x 280p</b></span
                    ><span class="form-control-photo-content__size"
                      >Max <b>5 MB</b></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side edit-popup__side--location-btn">
              <button
                type="submit"
                class="btn btn--green edit-popup__submit"
                @click="updateLocationHandler">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTerritoriesAll,
  API,
  getLocationsAll,
  createLocation,
  deleteLocation,
  getLocation,
  updateLocation,
  getTextsTerrDescriptions,
  updateTextsTerrDescriptions,
} from '@/utilites/api'

import Pagination from '@/components/Pagination'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
import { getLanguageIcon, getLanguageTitle } from '../../common/helpers/language'

export default {
  props: ['user', 'uploadedFile'],
  components: {BasicInput, Pagination, editor: CKEditor.component},
  data() {
    return {
      API: API,
      editor: ClassicEditor,
      locationsData: [],
      locations: [],
      territories: [],
      territoriesEdit: [],
      isEditFlag: false,
      idPhoto: null,
      add: {
        title: '',
        transfer: false,
        googlePlaceId: null,
        names: {
          EN: '',
          RU: '',
          DE: '',
          ES: '',
          FR: '',
          PT: '',
          NL: '',
        },
      },
      // selects: {
      //   territory: false,
      //   territoryEdit: false,
      // },
      lang: {
        territoriesDescription: 'EN',
      },
      data: {
        DE: {
          territoriesDescription: '',
        },
        RU: {
          territoriesDescription: '',
        },
        EN: {
          territoriesDescription: '',
        },
        ES: {
          territoriesDescription: '',
        },
        FR: {
          territoriesDescription: '',
        },
        PT: {
          territoriesDescription: '',
        },
        NL: {
          territoriesDescription: '',
        },
      },
      selects: {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
      },
      page: 1,
      pageCount: 0,
      search: '',
      isPopup: false,
      edit: null,
      isLoad: false,
      isEdit: false,
      errors: {
        title: false,
        territory: false,
        googlePlaceId: false,
      },
      errorsEdit: {
        title: false,
        territory: false,
        googlePlaceId: false,
      },
      langEdit: 'EN',
      editorConfig: {
        placeholder: 'Write text',
      },
      currentLocationData: null,
      currentLocationId: null,
      uploadedFileId: null,
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Geo / Location'
  },
  mounted() {
    document.title = 'Setting & Data / Geo / Location'

    getTerritoriesAll(this.user.access_token).then((res) => {
      this.territories = res.map((item, index) => ({...item, active: false}))
      this.territoriesEdit = res.map((item, index) => ({
        ...item,
        active: false,
      }))
    })
    this.updateData()
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          territory: false,
          territoryEdit: false,
        }
      }
      if (
        !event.target.closest('.edit-popup') &&
        !event.target.closest('.btn')
      ) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit,
          })
        } else {
          // this.edit = false
        }
      }
    })
  },
  methods: {
    getLanguageTitle,
    getLanguageIcon,
    currentLangSelectOption(lang) {
      this.langEdit = lang
      this.lang.territoriesDescription = lang
    },
    changeSelects(target) {
      this.selects = {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
        [target]: !this.selects[target],
      }
    },
    checkErrors() {
      this.errors = {
        // title: /[^A-Za-z0-9\- ]/g.test(this.add.title.trim()) || this.add.title.trim().length === 0,
        territory: !this.territories.find((item) => item.active),
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      return error
    },
    checkErrorsEdit() {
      this.errorsEdit = {
        // title: /[^A-Za-z0-9\- ]/g.test(this.edit.title.trim()) || this.edit.title.trim().length === 0,
        territory: !this.territoriesEdit.find((item) => item.active),
      }
      let error = false
      for (const key in this.errorsEdit) {
        if (this.errorsEdit[key]) {
          error = true
        }
      }
      return error
    },
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.locations.length / 15)
    },
    addLocationHandler() {
      if (!this.checkErrors()) {
        createLocation(this.user.access_token, {
          names: {
            EN: this.add.title,
            RU: this.add.title,
            DE: this.add.title,
            ES: this.add.title,
            FR: this.add.title,
            PT: this.add.title,
            NL: this.add.title,
          },
          territory: this.territories.find((item) => item.active).id,
          transfer: false,
          googlePlaceId: this.add.googlePlaceId,
        })
          .then(() => {
            this.updateData()
            this.add = {
              title: '',
              transfer: false,
              googlePlaceId: null,
            }
            this.territories = this.territories.map((item) => ({
              ...item,
              active: false,
            }))
            this.$emit('confirmed')
          })
          .catch(() => {
            this.errors.title = true
          })
      }
    },
    editLocation(id) {
      // console.log('id', id)
      this.uploadedFileId = null
      getLocation(this.user.access_token, id).then((res) => {
        this.edit = res
        this.territoriesEdit = this.territoriesEdit.map((item) => ({
          ...item,
          active:
            this.locations.find((ter) => ter.location.id === id).territory
              .id === item.id,
        }))

        getTextsTerrDescriptions().then((res) => {
          // console.log('getTextsTerrDescriptions', res)
          this.data.DE.territoriesDescription = ''
          this.data.RU.territoriesDescription = ''
          this.data.EN.territoriesDescription = ''
          this.data.ES.territoriesDescription = ''
          this.data.FR.territoriesDescription = ''
          this.data.PT.territoriesDescription = ''
          this.data.NL.territoriesDescription = ''
          this.currentLocationData = res.filter((r) => r.locationId === id)

          if (!this.currentLocationData.length) {
            // console.log('getTextsTerrDescriptions NULL', id)
            this.currentLocationId = id
          }

          if (this.currentLocationData.length) {
            this.data.DE.territoriesDescription =
              this.currentLocationData[0].texts.DE
            this.data.RU.territoriesDescription =
              this.currentLocationData[0].texts.RU
            this.data.EN.territoriesDescription =
              this.currentLocationData[0].texts.EN
            this.data.ES.territoriesDescription =
              this.currentLocationData[0].texts.ES
            this.data.FR.territoriesDescription =
              this.currentLocationData[0].texts.FR
            this.data.PT.territoriesDescription =
              this.currentLocationData[0].texts.PT
            this.data.NL.territoriesDescription =
              this.currentLocationData[0].texts.NL

            this.currentLocationId = this.currentLocationData[0].locationId

            // console.log('this.currentLocationData', this.currentLocationData)
          }
        })
      })
    },
    updateLocationHandler() {
      if (!this.checkErrorsEdit()) {
        updateLocation(this.user.access_token, {
          id: this.edit.id,
          names: this.edit.names,
          territory: this.territoriesEdit.find((item) => item.active).id,
          transfer: false,
          googlePlaceId: this.edit.googlePlaceId,
        }).then(() => {
          this.$emit('confirmed')
          this.updateData()
          this.edit = null
          this.isEdit = false
        })

        if (
          this.uploadedFileId === null &&
          this.currentLocationData[0].photoId === null
        ) {
          this.uploadedFileId = null
        }

        if (
          this.uploadedFileId === null &&
          this.currentLocationData[0].photoId !== null
        ) {
          this.uploadedFileId = this.currentLocationData[0].photoId
        }

        updateTextsTerrDescriptions({
          descriptions: [
            {
              locationId: this.currentLocationId,
              texts: {
                EN: this.data.EN.territoriesDescription,
                DE: this.data.DE.territoriesDescription,
                RU: this.data.RU.territoriesDescription,
                ES: this.data.ES.territoriesDescription,
                FR: this.data.FR.territoriesDescription,
                PT: this.data.PT.territoriesDescription,
                NL: this.data.NL.territoriesDescription,
              },
              photoId: this.uploadedFileId,
            },
          ],
        })
      }
    },
    deleteLocationHandler(id) {
      deleteLocation(this.user.access_token, id)
        .then(() => {
          this.$emit('confirmed')
          this.updateData()
        })
        .catch(() =>
          this.$emit(
            'errored',
            'You cannot delete Location, if they have bound fields "Area"'
          )
        )
    },
    updateData() {
      this.isLoad = false
      getLocationsAll(this.user.access_token).then((res) => {
        this.isLoad = true
        this.locations = res
          .map((item, index) =>
            index === 0
              ? {...item, active: true}
              : {
                  ...item,
                  active: false,
                }
          )
          .sort(
            (a, b) =>
              new Date(b.location.createdAt).getTime() -
              new Date(a.location.createdAt).getTime()
          )
        this.locationsData = res
          .map((item, index) =>
            index === 0
              ? {...item, active: true}
              : {
                  ...item,
                  active: false,
                }
          )
          .sort(
            (a, b) =>
              new Date(b.location.createdAt).getTime() -
              new Date(a.location.createdAt).getTime()
          )
      })
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
    },
  },
  watch: {
    locations() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.locations = this.locationsData
      }
      this.page = 1
      let filtered = this.locationsData.filter((item) =>
        this.search.length
          ? item.location.names.EN &&
            item.location.names.EN.toLowerCase().includes(
              this.search.toLowerCase()
            )
            ? item
            : false
          : item
      )
      this.locations = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    },
    uploadedFile() {
      this.uploadedFileId = this.uploadedFile
    },
  },
}
</script>
<style scoped lang="scss">
.add-block__container {
  display: flex;
  margin: 10px 0;
}
</style>